import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

import { queryObj } from '../../types';

const PaymentResponse = () => {
  const navigate = useNavigate();
  const urlString = window.document.URL;
  const url = new URL(urlString);
  const [response, setResponse] = useState<queryObj>({});
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [data, setData] = useState(0);
  const queryStringValue = url.search.substring(1);
  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  useEffect(() => {
    decodeURI(queryStringValue)
      .split('&')
      .map((item) => {
        const v = item.split('=');
        response[v[0]] = v[1];
      });
    setResponse(response);
    setData(1);
  }, []);

  return (
    <div className='container  main-container'>
      <ArrowBackIcon
        className='position-absolute'
        style={{ cursor: 'pointer' }}
        onClick={() => navigate(-1)}
        data-testid='svg-back'
      />
      <Paper style={{ padding: '12px', marginLeft: '32px' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label='payment table'>
            <TableBody>
              {Object.keys(response).map((key, index) => (
                <StyledTableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <StyledTableCell
                    component='th'
                    scope='row'
                    align='left'
                    className='fw-bold text-capitalize'
                  >
                    {key}
                  </StyledTableCell>
                  <StyledTableCell align='left'>
                    {key === 'amount'
                      ? response[key].slice(0, -2) + '.' + response[key].slice(-2)
                      : response[key]}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default PaymentResponse;
